import { useRef } from 'react';
import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealCompletionReportImage } from '~/models/DealReportImage';

const paths = {
  index: '/deals/:deal_id/deal_completion_report_images'
};

type TIndex = (id: number | null) => SwrReturnType<DealCompletionReportImage[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealCompletionReportImages = (): ReturnType => {
  const cachedDataRef = useRef<DealCompletionReportImage[] | null>(null);

  const index: TIndex = (dealId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<DealCompletionReportImage[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );

    if (data) {
      cachedDataRef.current = data;
    }

    return {
      data: data ?? cachedDataRef.current,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
